<!-- Start::menu item (lg+) -->
<div class="hidden lg:block">
  <h2 class="fw-bold" style="font-size: 14px">Sobre Nosotros</h2>
  <hr class="my-2" style="background-color: #646462" />

  <div>
    <ul>
      @for (link of links; track $index) {
      <li>
        <a [routerLink]="link.url">{{ link.label }}</a>
      </li>
      } @if(country === 'cl') {
      <li>
        <a href="https://implementos.trabajando.cl/" target="_blank"
          >Trabaja con Nosotros <i class="fas fa-briefcase"></i
        ></a>
      </li>
      }
    </ul>
  </div>

  <h2 class="fw-bold mt-5" style="font-size: 14px">Síguenos</h2>
  <hr class="mb-2 mt-0" style="background-color: #646462" />

  <a
    class="me-1"
    [href]="config.company.facebook"
    rel="noopener"
    target="_blank"
  >
    <img
      src="../../../../../assets/svg/17.svg"
      style="width: 20px; height: 20px"
      alt="facebook"
    />
  </a>
  <a
    class="me-2"
    [href]="config.company.instagram"
    target="_blank"
    rel="noopener"
  >
    <img
      src="../../../../../assets/svg/18.svg"
      style="width: 20px; height: 20px"
      alt="instagram"
    />
  </a>
  <a [href]="config.company.linkedin" target="_blank" rel="noopener">
    <img
      src="../../../../../assets/svg/19.svg"
      style="width: 20px; height: 20px"
      alt="linkedin"
    />
  </a>
</div>
<!-- End::menu item (lg+) -->

<!-- Start::menu item (xs, sm y md) -->
<div class="block lg:hidden">
  <div
    class="col-12 py-0"
    data-bs-toggle="collapse"
    data-bs-target="#nosotros-xs"
    [attr.aria-expanded]="terminos"
    aria-controls="nosotros-xs"
  >
    <div class="row">
      <div class="col-8 py-0 flex justify-content-start">
        <h3 class="fw-bold text-center">Sobre Nosotros</h3>
      </div>
      <div class="col-4 py-0 flex justify-content-end">
        <i class="fa-solid fa-chevron-down"></i>
      </div>
    </div>
  </div>
  <hr class="my-2" style="background-color: #646462" />

  <div
    class="collapse multi-collapse"
    [ngClass]="terminos ? 'show' : ''"
    id="nosotros-xs"
  >
    <ul>
      @for (link of links; track $index) {
      <li class="ps-3">
        <a [routerLink]="link.url">{{ link.label }}</a>
      </li>
      } @if(country === 'cl') {
      <li class="ps-3">
        <a href="https://implementos.trabajando.cl/" target="_blank"
          >Trabaja con Nosotros <i class="fas fa-briefcase"></i
        ></a>
      </li>
      }
    </ul>
    <hr class="my-2" style="background-color: #646462" />
  </div>
</div>
<!-- End::menu item (xs, sm y md) -->
